export default __webpack_public_path__ + "static/media/stopIconSemSobra.93ac12e3.svg";